import AvField from "availity-reactstrap-validation/lib/AvField"
import AvForm from "availity-reactstrap-validation/lib/AvForm"
import { Modal, Row, Col, Alert } from "reactstrap"
import Location from "./Location"
import { useState, useEffect } from "react"
import General from "services/GeneralEndpoints"
import { Link } from "react-router-dom"

const user = JSON.parse(localStorage.getItem("authUser"))
let generalService = new General(user)

const CompanyModal = props => {
  const [open, setopen] = useState(false)
  const [error, seterror] = useState()
  const [loading, setloading] = useState(false)
  const [formData, setFormData] = useState({
    name: "",
    company_category_id: "",
    type_registration: "",
    tin: "",
    telephone: "",
    email: "",
    avgMonthlyPlasticQuantity: "",
    activities: "",
    address: "",
    contact_person_name: "",
    contact_person_job_title: "",
    contact_person_phone: "",
    contact_person_email: "",
    province_id: "",
    district_id: "",
    sector_id: "",
    cell_id: "",
  })
  const [companyCategories, setcompanyCategories] = useState()

  useEffect(() => {
    fetchCompanyCategories()
  }, [])

  useEffect(() => {
    setopen(props.open)
  }, [props.open])

  useEffect(() => {
    setloading(props.loading)
  }, [props.loading])

  useEffect(() => {
    seterror(props.error)
  }, [props.error])

  // Pre-fill form fields when editing
  useEffect(() => {
    if (props.company) {
      setFormData({
        name: props.company.name || "",
        company_category_id: props.company.company_category_id || "",
        type_registration: props.company.type_registration || "",
        tin: props.company.tin || "",
        telephone: props.company.telephone || "",
        email: props.company.email || "",
        avgMonthlyPlasticQuantity:
          props.company.average_monthly_plastic_quantity || "",
        activities: props.company.activities || "",
        address: props.company.address || "",
        contact_person_name: props.company.contact_person_name || "",
        contact_person_job_title: props.company.contact_person_job_title || "",
        contact_person_phone: props.company.contact_person_phone || "",
        contact_person_email: props.company.contact_person_email || "",
        province_id: props.company.province_id || "",
        district_id: props.company.district_id || "",
        sector_id: props.company.sector_id || "",
        cell_id: props.company.cell_id || "",
      })
    }
  }, [props.company])

  function toggle() {
    setopen(!open)
    removeBodyCss()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  const fetchCompanyCategories = () => {
    generalService.getCompanyCategories().then(response => {
      if (response.status) {
        const cats = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })
        setcompanyCategories(cats)
      }
    })
  }

  const handleInputChange = e => {
    const { name, value } = e.target
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }))
  }

  const submitRegistration = values => {
    props.submit({
      ...formData,
      province_id: values.province_id,
      district_id: values.district_id,
      sector_id: values.sector_id,
      cell_id: values.cell_id,
    })
  }

  return (
    <Modal
      size="lg"
      isOpen={open}
      toggle={() => {
        toggle()
      }}
      scrollable={false}
    >
      <div className="modal-header">
        <h3 className="modal-title" id="staticBackdropLabel">
          {props.company ? "Edit Company" : "Add Company"}
        </h3>
        <button
          type="button"
          className="btn-close"
          onClick={() => {
            props.toggleModal()
          }}
          aria-label="Close"
        ></button>
      </div>
      
      <AvForm className="mt-4" onValidSubmit={(e, v) => {submitRegistration(v)}}>
        <div className="modal-body">
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "center",
            }}
          ></div>
          {error ? <Alert color="danger">{error}</Alert> : null}

          <div className="p-2">
            <Row>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="name"
                    label="Company Name"
                    type="text"
                    required
                    placeholder="Enter Company Name"
                    value={formData.name}
                    onChange={handleInputChange}
                  />
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="company_category_id"
                    label="Company Category"
                    type="select"
                    required
                    value={formData.company_category_id}
                    onChange={handleInputChange}
                  >
                    <option>--Select--</option>
                    {companyCategories}
                  </AvField>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="type_registration"
                    label="Registration Type"
                    type="text"
                    required
                    value={formData.type_registration}
                    onChange={handleInputChange}
                  />
                </div>
              </Col>

              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="tin"
                    label="Tax Identification Number"
                    type="text"
                    required
                    placeholder="Enter TIN"
                    value={formData.tin}
                    onChange={handleInputChange}
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="telephone"
                    label="Phone"
                    type="phone"
                    validate={{
                      required: { value: true },
                      maxLength: {
                        value: 10,
                        errorMessage: "Enter a 10 digit phone number.",
                      },
                      minLength: {
                        value: 10,
                        errorMessage: "Enter a 10 digit phone number.",
                      },
                    }}
                    placeholder="Enter Phone Number"
                    value={formData.telephone}
                    onChange={handleInputChange}
                  />
                </div>
              </Col>

              <Col md="6">
                <div className="mb-3">
                  <AvField
                    id="email"
                    name="email"
                    label="Email"
                    className="form-control"
                    placeholder="Enter email"
                    type="email"
                    required
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col md="12">
                <div className="mb-3">
                  <AvField
                    id="avgMonthlyPlasticQuantity"
                    name="avgMonthlyPlasticQuantity"
                    label="Average quantity of Plastics used per month (Kg)"
                    className="form-control"
                    placeholder="Enter average quantity"
                    type="number"
                    required
                    value={formData.avgMonthlyPlasticQuantity}
                    onChange={handleInputChange}
                  />
                  <Alert className="mt-1" color="info">
                    Average quantity of plastics used in your company per month.
                    This measure should be in Kilograms (Kg)
                  </Alert>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <div className="mb-3">
                  <AvField
                    name="activities"
                    label="Activities"
                    className="form-control"
                    placeholder="Enter Activities"
                    type="textarea"
                    required
                    value={formData.activities}
                    onChange={handleInputChange}
                  ></AvField>
                </div>
              </Col>
            </Row>

            <hr></hr>
            <h5>Location Details</h5>
            <Row>
              <Col md="12">
                <div className="mb-3">
                  <AvField
                    name="address"
                    label="Address"
                    className="form-control"
                    placeholder="Enter Address"
                    type="text"
                    required
                    value={formData.address}
                    onChange={handleInputChange}
                  />
                </div>
              </Col>
            </Row>

            <Location
              province_id={formData.province_id || ""}
              district_id={formData.district_id || ""}
              sector_id={formData.sector_id || ""}
              cell_id={formData.cell_id || ""}
            />

            <hr></hr>
            <h5>Contact Person Details</h5>
            <Row>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="contact_person_name"
                    label="Name"
                    type="text"
                    placeholder="Enter Name"
                    value={formData.contact_person_name}
                    onChange={handleInputChange}
                  />
                </div>
              </Col>

              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="contact_person_job_title"
                    label="Job Title"
                    className="form-control"
                    placeholder="Enter Job Title"
                    type="text"
                    required
                    value={formData.contact_person_job_title}
                    onChange={handleInputChange}
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="contact_person_phone"
                    label="Phone"
                    type="phone"
                    validate={{
                      required: { value: true },
                      maxLength: {
                        value: 10,
                        errorMessage: "Enter a 10 digit phone number.",
                      },
                      minLength: {
                        value: 10,
                        errorMessage: "Enter a 10 digit phone number.",
                      },
                    }}
                    placeholder="Enter Phone Number"
                    value={formData.contact_person_phone}
                    onChange={handleInputChange}
                  />
                </div>
              </Col>

              <Col md="6">
                <div className="mb-3">
                  <AvField
                    name="contact_person_email"
                    label="Email"
                    className="form-control"
                    placeholder="Enter email"
                    type="email"
                    required
                    value={formData.contact_person_email}
                    onChange={handleInputChange}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-light"
            onClick={() => {
              props.toggleModal()
            }}
          >
            Close
          </button>
          {loading ? (
            <Link to="#" className="spinner-border text-info" />
          ) : (
            <button
              // onClick={submitRegistration}
              type="submit"
              className="btn btn-primary"
            >
              {props.company ? "Update Company" : "Add Company"}
            </button>
          )}
        </div>
      </AvForm>
    </Modal>
  )
}

export default CompanyModal
